<!-- Spinner -->

<!-- Data View -->
@if (nodeSharedFacade.currentSelectedBlockNode$ | async; as blockNode) {
  @let layout = (slideAuthorFacade.layout$ | async) ?? 'list';
  @if (nodeSharedFacade.nodeByIds$(blockNode.children) | async | sortBy_shared:'asc':'position'; as nodes) {
    <medsurf-design-content-sortable-data-view #slides_data_view
      [value]="nodes"
      [gridStyleClass]="'flex flex-wrap gap-2 p-2'"
      [listStyleClass]="'p-2'"
      [paginatorDropdownScrollHeight]="'300px'"
      [trackBy]="trackBy"
      [rows]="10"
      [layout]="layout"
      (onChangeLayout)="changeLayout($event)"
      [parent]="blockNode"
      (onNodeMoved)="onNodeMoved($event.parent, $event.children)">
      <!-- Header -->
      <ng-template pTemplate="header"
        class="overflow-auto h-full">
        <div class="flex flex-wrap gap-2 justify-content-between w-full p-2">
          <div class="flex flex-shrink-0 align-items-center gap-2">
            @if (layout === 'grid') {
              @if ({
                hasAllBulkEditNodes: (nodeSharedFacade.hasAllBulkEditNodes$(blockNode.children) | async) || false
              }; as bulkData) {
                <medsurf-design-input-checkbox [formField]="false"
                  [name]="'slide_select_all'"
                  [class]="'table-header-switch'"
                  [model]="bulkData.hasAllBulkEditNodes"
                (valueChange)="onToggleBlockChildrenBulkNodes(blockNode, !bulkData.hasAllBulkEditNodes)"></medsurf-design-input-checkbox>
              }
            }
            <span>
              {{ blockNode.children.length }} {{ 'global.slides' | translate}}
            </span>
          </div>
          @if ({
            pageIdsFromSelectNodeSet: bulkEditAuthorFacade.pageIdsFromSelectNodeSet$ | async,
            selectNodeSet: bulkEditAuthorFacade.selectNodeSet$ | async,
            copyNodeSet: bulkEditAuthorFacade.copyNodeSet$ | async,
            pageIdsFromSelectNodeSet$: bulkEditAuthorFacade.pageIdsFromSelectNodeSet$ | async,
            nodesVisible: bulkEditAuthorFacade.nodesVisible$ | async,
            selectPageSet: bulkEditAuthorFacade.selectPageSet$ | async,
            copyPageSet: bulkEditAuthorFacade.copyPageSet$ | async
          }; as nodeData) {
            <div
              class="flex flex-wrap gap-2"
              >
              @if (nodeData.selectNodeSet?.size === 0 && (nodeData.copyNodeSet?.size || 0) > 0) {
                @if (nodeSharedFacade.currentSelectedBlockNode$ | async; as parentNode) {
                  <button medsurf-design-input-button [id]="'slides_paste_nodes'"
                    [label]="'global.paste_desc' | translate: {count: nodeData.copyNodeSet?.size}"
                    [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.PRIMARY"
                    [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.PASTE_MR_2"
                  (click)="pasteNodes(parentNode)"></button>
                }
              }
              @if ((nodeData.selectNodeSet?.size || 0) > 0) {
                <button medsurf-design-input-button [id]="'slides_deselect_nodes'"
                  [label]="'global.selection_desc' | translate: {count: nodeData.selectNodeSet?.size || 0}"
                  [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY"
                  [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.TIMES_MR_2"
                (click)="deselectNodes()"></button>
                <div medsurf-design-content-input-group>
                  <medsurf-design-input-menu [formField]="false"
                    [name]="'slides_duplicate_menu'"
                    [tooltipLabel]="'global.slides_duplicate' | translate"
                    [buttonIconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.DUPLICATE"
                    [menuClass]="FlatModels.PanelDesignModels.MenuDesignClass.WHITE"
                  [loadMenuItems]="getSlidesCloneMenuItems"></medsurf-design-input-menu>
                  <button medsurf-design-input-button [id]="'slides_copy_nodes'"
                    [title]="'global.nodes_copy' | translate"
                    [disabled]="nodeData.selectNodeSet?.size === 0"
                    [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.PRIMARY"
                    [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.COPY"
                  (click)="copyNodes()"></button>
                  @if (nodeSharedFacade.currentSelectedBlockNode$ | async; as parentNode) {
                    <button medsurf-design-input-button [id]="'slides_paste_nodes'"
                      [title]="'global.nodes_paste' | translate"
                      [disabled]="nodeData.copyPageSet?.size === 0"
                      [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.PRIMARY"
                      [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.PASTE"
                    (click)="pasteNodes(parentNode)"></button>
                  }
                  <button medsurf-design-input-button [id]="'slides_remove_nodes'"
                    [title]="'global.nodes_remove' | translate"
                    [disabled]="nodeData.selectNodeSet?.size === 0"
                    [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.PRIMARY"
                    [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.REMOVE"
                  (click)="removeNodes()"></button>
                  <medsurf-design-input-menu [formField]="false"
                    [name]="'slides_others_menu'"
                    [tooltipLabel]="'global.node_menu' | translate"
                    [iconOpen]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.OPTIONS"
                    [iconClose]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.OPTIONS"
                    [menuClass]="FlatModels.PanelDesignModels.MenuDesignClass.WHITE"
                  [loadMenuItems]="getSlidesOthersMenuItems"></medsurf-design-input-menu>
                </div>
              }
            </div>
          }
          <div class="flex flex-shrink-0 gap-2">
            @if (nodeSharedFacade.currentSelectedRouteElement$ | async; as routeElement) {
              <medsurf-design-input-split-button
                [formField]="false"
                [name]="'slide_add_menu'"
                [tooltipLabel]="'global.slide_add' | translate"
                [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.PAGE_SLIDE"
                [iconClassAfter]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.ADD"
                [menuClass]="FlatModels.PanelDesignModels.MenuDesignClass.WHITE"
                [items]="slideAddMenuItems"
              (buttonClick)="addSlideSplitButton(routeElement)"></medsurf-design-input-split-button>
            }
            <!-- Layout Options -->
            <medsurf-design-content-sortable-data-view-layout-options [layout]="layout"></medsurf-design-content-sortable-data-view-layout-options>
          </div>
        </div>
        <div class="p-2">
          @if (layout === 'list') {
            <div class="table-head w-full h-4rem pl-2 cursor-pointer overflow-hidden"
              style="padding-right: 18px"
              >
              <div class="w-2rem">
                &nbsp;
              </div>
              <div class="w-2rem">
                &nbsp;
              </div>
              <div class="w-3rem flex-shrink-0">
                @if ({
                  hasAllBulkEditNodes: (nodeSharedFacade.hasAllBulkEditNodes$(blockNode.children) | async) || false
                }; as bulkData) {
                  <medsurf-design-input-checkbox [formField]="false"
                    [name]="'slide_select_all'"
                    [class]="'table-header-switch'"
                    [model]="bulkData.hasAllBulkEditNodes"
                  (valueChange)="onToggleBlockChildrenBulkNodes(blockNode, !bulkData.hasAllBulkEditNodes)"></medsurf-design-input-checkbox>
                }
              </div>
              <div class="w-5rem flex-shrink-0">
                &nbsp;
              </div>
              <span translate="global.slide_id"
              class="w-5rem"></span>
              <span translate="global.title"
              class="w-20rem flex-grow-1"></span>
              <span translate="global.resource_type"
              class="w-8rem"></span>
              <span translate="global.modality"
              class="w-13rem"></span>
              <span translate="global.status"
              class="w-5rem"></span>
            </div>
          }
        </div>
      </ng-template>
      <!-- Content -->
      <!-- List Item -->
      <ng-template pTemplate="listItem"
        let-node>
        @if ({
          page: appSharedFacade.page$(node.page) | async,
          hasBulkEditNode: (nodeSharedFacade.hasBulkEditNode$(node.id) | async) || false,
          typedRouteElements: nodeSharedFacade.typedRouteElements$ | async
        }; as pageData) {
          @if (pageData.page) {
            <div [id]="'s-' + node.id"
              class="table-row h-5rem pl-2 cursor-pointer overflow-hidden hover:bg-primary-200 drag-node"
              [ngClass]="{'bg-primary-300': pageData.hasBulkEditNode}"
              (click)="pageData.typedRouteElements && onNodeClick($event, node, pageData.typedRouteElements)">
              <div class="w-2rem">
                {{ node.position + 1 }}
              </div>
              <div class="w-2rem">
                <button medsurf-design-input-button [id]="'list_slide_handle_' + node.id"
                  [title]="'global.slide_handle' | translate"
                  [class]="'handle cursor-move'"
                  [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.HANDLE_OUTLINED"
                [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.MOVE"></button>
              </div>
              <div class="w-3rem flex-shrink-0">
                <medsurf-design-input-checkbox [formField]="false"
                  [name]="'slide_list_select_' + node.id"
                  [model]="pageData.hasBulkEditNode"
                (valueChange)="onToggleBulkNode(node.id, node.parentId)"></medsurf-design-input-checkbox>
              </div>
              <div class="w-5rem flex-shrink-0">
                @if (pageData.page?.thumbnailMedia) {
                  @if ({
                    media: appSharedFacade.media$(pageData.page.thumbnailMedia) | async
                  }; as mediaData) {
                    <img
                      class="block h-4rem w-4rem bg-black-alpha-30"
                      [src]="mediaControlService.getUrl(mediaData.media, 'thumbnail') || '/assets/images/no-image.png'"
                      [alt]="mediaData.media?.name || 'global.error_loading_image' | translate" />
                  }
                }
              </div>
              <span class="w-5rem">
                {{ pageData?.page?.slideId || '-' }}
              </span>
              <span class="w-20rem flex-grow-1 text-overflow-ellipsis-2">
                {{ pageData.page.title }}
              </span>
              <span class="w-8rem">
                {{ mediaControlService.getMediaTypeLabelByType(pageData.page.mediaType) | translate }}
              </span>
              @if ({
                modality: appSharedFacade.modality$(pageData.page.modality) | async
              }; as modalityData) {
                <span
                  class="w-13rem">
                  {{ modalityData?.modality?.name || '-' }}
                </span>
              }
              <span class="w-5rem">
                {{ pageData.page.status | translate }}
              </span>
            </div>
          }
        }
      </ng-template>
      <!-- Grid Item -->
      <ng-template pTemplate="gridItem"
        let-node>
        @if ({
          page: appSharedFacade.page$(node.page) | async,
          hasBulkEditNode: (nodeSharedFacade.hasBulkEditNode$(node.id) | async) || false,
          typedRouteElements: nodeSharedFacade.typedRouteElements$ | async
        }; as pageData) {
          <div [id]="'s-' + node.id"
            class="flex flex-column w-12rem h-16rem border-1 border-round cursor-pointer overflow-hidden hover:border-primary-200 hover:bg-primary-200 drag-node"
            [ngClass]="{'bg-primary-300': pageData.hasBulkEditNode}"
            [title]="pageData.page.title"
            (click)="pageData.typedRouteElements && onNodeClick($event, node, pageData.typedRouteElements)">
            <div class="relative flex w-12rem h-12rem">
              <div class="absolute top-0 left-0 m-2 flex gap-1">
                <button medsurf-design-input-button [id]="'grid_slide_handle_' + node.id"
                  [title]="'global.slide_handle' | translate"
                  [class]="'handle cursor-move'"
                  [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.HANDLE_OUTLINED"
                [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.MOVE"></button>
                @if (pageData.page.slideId) {
                  <medsurf-design-content-chip
                    [tooltipLabel]="'global.slide_id' | translate">
                    {{ pageData.page.slideId }}
                  </medsurf-design-content-chip>
                }
              </div>
              <medsurf-design-input-checkbox
                [formField]="false"
                [name]="'slide_grid_select_' + node.id"
                [class]="'h-3rem absolute top-0 right-0'"
                [model]="pageData.hasBulkEditNode"
                (valueChange)="onToggleBulkNode(node.id, node.parentId)"
              ></medsurf-design-input-checkbox>
              <div class="absolute bottom-0 left-0 m-2 flex flex-1 gap-1">
                <medsurf-design-content-chip [tooltipLabel]="'global.position' | translate">
                  #{{ node.position + 1 }}
                </medsurf-design-content-chip>
                @if (pageData.page.status && pageData.page.status !== FlatModels.PageEntityModels.SlideStatus.enum.empty) {
                  <medsurf-design-content-chip
                    [tooltipLabel]="'global.status' | translate"
                    [styleClass]="'p-menu_icon'">
                    <i [class]="nodeSharedFacade.getSlideStatusIcon(pageData.page)"></i>
                  </medsurf-design-content-chip>
                }
                <medsurf-design-content-chip [tooltipLabel]="'global.file_type' | translate"
                  [styleClass]="'p-menu_icon'">
                  <i [class]="mediaControlService.getMediaTypeIconByType(pageData.page.mediaType)"></i>
                </medsurf-design-content-chip>
                @if (pageData.page.type === FlatModels.PageEntityModels.PageType.enum.Training) {
                  <medsurf-design-content-chip
                    [tooltipLabel]="'enum.pageType.Training' | translate"
                    [styleClass]="'p-menu_icon'">
                    <i [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.PAGE_TRAINING"></i>
                  </medsurf-design-content-chip>
                }
              </div>
              @if ({
                marked: bookmarkAuthorFacade.nodeBookmarked$(node.id) | async
              }; as bookmarkData) {
                <medsurf-design-content-chip
                  [tooltipLabel]="'global.bookmark' | translate"
                  [class]="'absolute bottom-0 right-0 m-2'"
                  [styleClass]="'p-menu_icon'"
                  (click)="onToggleBookmark(node, pageData.page)">
                  @if (bookmarkData.marked === true) {
                    <i
                    [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.BOOKMARK + FlatModels.ButtonDesignModels.ButtonDefaultIconsStyle.WARNING + FlatModels.ButtonDesignModels.ButtonSolidStyle"></i>
                  }
                  @if (bookmarkData.marked === false) {
                    <i
                    [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.BOOKMARK"></i>
                  }
                </medsurf-design-content-chip>
              }
              @if ({
                media: appSharedFacade.media$(pageData.page.thumbnailMedia) | async
              }; as mediaData) {
                <img
                  class="w-full bg-black-alpha-30"
                  [src]="mediaControlService.getUrl(mediaData.media, 'thumbnail') || '/assets/images/no-image.png'"
                  [alt]="mediaData.media?.name || 'global.error_loading_image' | translate" />
              }
            </div>
            <div class="flex w-12rem align-items-start h-4rem p-2">
              <span class="overflow-hidden text-overflow-ellipsis-2">
                {{ pageData.page.title }}
              </span>
            </div>
          </div>
        }
      </ng-template>
    </medsurf-design-content-sortable-data-view>
  } @else {
    <medsurf-design-content-process-spinner></medsurf-design-content-process-spinner>
  }
} @else {
  <medsurf-design-content-process-spinner></medsurf-design-content-process-spinner>
}
